import { ClassValue, clsx } from "clsx";
import {
	differenceInDays,
	format,
	formatDistanceToNowStrict,
	isAfter,
	parseISO,
	subDays,
} from "date-fns";
import { snakeCase } from "lodash-es";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function formatDate(input: string | number): string {
	const date = new Date(input);
	return date.toLocaleDateString("en-US", {
		month: "long",
		day: "numeric",
		year: "numeric",
	});
}

export function formatTiming({
	date,
	pattern = "yyyy-MM-dd HH:mm:ss",
}: {
	date: string;
	pattern?: string;
}): string {
	const daysAgo = differenceInDays(new Date(), new Date(date));

	if (daysAgo === 0) {
		return "Today";
	}
	if (daysAgo <= 31) {
		return formatDistanceToNowStrict(new Date(date), { addSuffix: true });
	}
	return `${format(new Date(date), pattern)}`;
}

export function updateUrlParam(paramName: string, paramValue: any) {
	let url = new URL(window.location.href);
	url.searchParams.set(paramName, paramValue);
	window.history.replaceState(window.history.state, "", url.toString());
}

export function removeUrlParam(paramName: string) {
	let url = new URL(window.location.href);
	url.searchParams.delete(paramName);
	window.history.replaceState(window.history.state, "", url.toString());
}

export function getWordCount(text: string) {
	return String(text || "")
		?.replace(/<[^>]+>/g, "")
		?.split(" ").length;
}

export function getTotalFAQsWordCount(array: Array<{ quick_summary?: string; summary?: string }>) {
	return array?.reduce((acc, curr) => {
		const quickSummaryCount = getWordCount(curr.quick_summary || "");
		const summaryCount = getWordCount(curr.summary || "");
		return acc + quickSummaryCount + summaryCount;
	}, 0);
}

// export const convertKeysToSnakeCase = (obj) =>
// 	Object.fromEntries(Object.entries(obj).map(([key, value]) => [snakeCase(key), value]));

// export const convertArrayKeysToSnakeCase = (array) =>
// 	array.map((obj) => convertKeysToSnakeCase(obj));
export const convertKeysToSnakeCase = (obj: any): any => {
	if (Array.isArray(obj)) {
		return obj.map(convertKeysToSnakeCase); // Recursively process arrays
	} else if (obj !== null && typeof obj === "object") {
		return Object.fromEntries(
			Object.entries(obj).map(([key, value]) => [
				snakeCase(key), // Convert key to snake_case
				convertKeysToSnakeCase(value), // Recursively process value
			])
		);
	}
	return obj; // Return as is if not an object or array
};

export const convertArrayKeysToSnakeCase = (array: any[]): any[] =>
	array.map(convertKeysToSnakeCase);

export function isWithinDays({ date, days }: { date: string; days: number }) {
	const dateObj = parseISO(date);
	const daysAgo = subDays(new Date(), days);

	return isAfter(dateObj, daysAgo);
}

export function trimPrice(price: number) {
	if (isNaN(price)) return "";

	return (price.toFixed(2) + "").replace(".00", "");
}

export function formatPrice(price: number) {
	return "$" + trimPrice(price);
}
